<template>
  <div>
    <CRow>
      <CCol sm="6">
        <CButton size="sm" @click="openModal" color="info">
          <i class="fa fa-envelope"></i>
          Blast
        </CButton>
        &nbsp;
        <CButton size="sm" @click="removeBlast" color="danger">
          <i class="fa fa-eraser"></i>
          Remove Blast
        </CButton>
      </CCol>
    </CRow>
    <CModal
      id="mod"
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title" v-if="isEdit === false">Add Form {{ title }}</h6>
        <h6 class="modal-title" v-if="isEdit === true">Remove Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol lg="4">
            <div class="form-group">
              <label for="user_group" v-if="isEdit === false"
                >Blast voucher ini ke group</label
              >
              <label for="user_group" v-if="isEdit === true"
                >Remove blast voucher ini ke group</label
              >
              <model-select
                class="form-control"
                id="user_group"
                :options="userGroupList"
                v-model="$v.voucherBlastForm.user_group.$model"
                :isError="$v.voucherBlastForm.user_group.$invalid"
                :isRequired="true"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.voucherBlastForm.user_group.$invalid"
                class="invalid-feedback-custom"
              >
                Agent should be filled.
              </div>
            </div>
          </CCol>

          <CCol lg="4">
            <div class="form-group">
              <label for="user_group" v-if="isEdit === false"
                >Blast voucher ini ke komunitas</label
              >
              <label for="user_group" v-if="isEdit === true"
                >Remove blast voucher ini ke komunitas</label
              >
              <model-select
                class="form-control"
                id="user_comunity"
                :options="userComunityList"
                v-model="$v.voucherBlastForm.user_comunity.$model"
                :isError="$v.voucherBlastForm.user_comunity.$invalid"
                :isRequired="true"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.voucherBlastForm.user_comunity.$invalid"
                class="invalid-feedback-custom"
              >
                Comunity should be filled.
              </div>
            </div>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="processBlast"
          :disabled="$v.voucherBlastForm.user_group.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";
import { required } from "vuelidate/lib/validators";

export default {
  name: "VoucherBlast",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Voucher Blast",
      items: [],
      voucherBlastForm: tableInterfaces.blast_voucher,
      isLoading: false,
      addButton: false,
      isEdit: false,
      user_group: null,
    };
  },
  props: {
    voucherStatus: {
      type: String,
      default: null,
    },
    voucher: {
      type: [Array, Object],
      default: () => [],
    },
    userGroupList: {
      type: [Array, Object],
      default: () => [],
    },
    userComunityList: {
      type: [Array, Object],
      default: () => [],
    },
  },
  validations: {
    voucherBlastForm: {
      user_group: { required },
      user_comunity: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.$emit("update:");
      // getProductList();
    },

    openModal: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    removeBlast: function () {
      this.addButton = true;
      this.isEdit = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.isEdit = true;
      this.voucherBlastForm = item;
      this.addButton = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.blast_voucher) {
        tableInterfaces.blast_voucher[i] = null;
      }
      this.voucherBlastForm = tableInterfaces.blast_voucher;
    },
    back: function () {
      this.$router.go(-1);
    },
    refreshVoucherAgent: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/voucher/voucher-agent/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            // if (response.data.total_row.total_row == 2) {
            //   this.enableAddPrice = false;
            // }
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    processBlast: function (event) {
      event.preventDefault();
      this.voucherBlastForm.voucher_code = this.voucher.voucher_code;
      if (this.isEdit === true) {
        if (confirm("Do you want to remove voucher from user ?")) {
          this.isLoading = true;
          this.axios
            .post("console/voucher/remove-blast", this.voucherBlastForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshVoucherAgent(this.voucher.id);
            });
        }
      } else {
        if (confirm("Do you want to blast voucher to user ?")) {
          this.isLoading = true;
          this.axios
            .post("console/voucher/blast", this.voucherBlastForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshVoucherAgent(this.voucher.id);
            });
        }
      }
    },
  },
  mounted() {},
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
